import { Input, Form, Button, FormProps, message } from "antd";
import LoginHeroImage from "~@/assets/images/login_hero.png";
import { ReactComponent as LogoIcon } from "~@/assets/images/logo-icon.svg";
import { ReactComponent as Logo } from "~@/assets/images/logo-text.svg";
import { useUser } from "~@/hooks/useUser";

const Login = () => {
  const setUser = useUser((state) => state.setUser);
  const onFinish: FormProps["onFinish"] = (values) => {
    const { user, password } = values;
    if (user === "test-pdd" && password === "test123456..") {
      setUser(values);
      message.success("登录成功");
      return;
    }
    message.error("用户名或密码错误");
    return;
  };
  return (
    <div data-page="login">
      <header className="flex items-center px-[40px] fixed top-0 w-full">
        <div className="space-x-1 flex items-center">
          <LogoIcon className="w-[32px] h-[22px]" />
          <Logo className="w-[64px] h-[22px]" />
        </div>
      </header>
      <div className="h-screen w-full flex items-center justify-center">
        <div className="grid grid-cols-2 board">
          <img src={LoginHeroImage} alt="" />
          <div className="form">
            <h1 className="text-black text-center font-medium title">
              立即登录
            </h1>
            <Form onFinish={onFinish}>
              <Form.Item
                name="user"
                rules={[{ required: true, message: "用户名不能为空" }]}
              >
                <Input placeholder="请输入用户名" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "密码不能为空" }]}
              >
                <Input.Password placeholder="请输入密码" />
              </Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                className="w-full mt-[40px] h-[40px]"
              >
                登录
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
